import { SET_USE_VEHICLE_SELECTION_MODAL } from "action/interfaces/utils.interface";

export function setUseVehicleSelectionModal(useVehicleSelectionOptionsModal: boolean): SET_USE_VEHICLE_SELECTION_MODAL {
  return {
    type: "SET_USE_VEHICLE_SELECTION_MODAL",
    data: useVehicleSelectionOptionsModal,
  };
}
